import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconSchool = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M2.5 9 12 4.5 21.5 9 12 13.5z' />
      <path d='M6.5 11v4.5c1.5 1.6 3.4 2.4 5.5 2.4s4-.8 5.5-2.4V11' />
      <path d='M21.5 9v5' />
    </g>
  </SDIcon>
)

export default IconSchool
